module.exports = __webpack_public_path__ + "brand-icons.a1d7a3d5d78b9164fff3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brand-icons/brand-icons.ttf?v=0.3.2
// module id = 891
// module chunks = 3